module.exports = "img/flags/YE.3a76dc4.png";